import React, { useReducer } from "react";
import { useContext } from "react";

const MealContext = React.createContext();
const MealContextDispatcher = React.createContext();
import { translateToReactSelect } from "admin-panel/create-tours/helperFunctions";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";

const initialState = [
  [
    {
      title: "گشت صبح",
      price: 0,
      id: 0,
      onvan: "",
      description: "",
      status: false,
      isPublic: true,
    },
    {
      title: "صبحانه",
      price: 0,
      id: 1,
      foodName: "",
      resturan: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "ناهار",
      price: 0,
      id: 2,
      foodName: "",
      resturan: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "میان وعده",
      price: 0,
      id: 3,
      onvan: "",
      status: false,
      isPublic: true,
    },
    {
      title: "گشت عصر ",
      price: 0,
      onvan: "",
      description: "",
      id: 4,
      status: false,
      isPublic: true,
    },
    {
      title: "شام",
      price: 0,
      id: 5,
      foodName: "",
      resturan: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "اقامتگاه",
      price: 0,
      id: 6,
      onvan: "",
      noeEghamat: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "برنامه شب",
      price: 0,
      onvan: "",
      description: "",
      id: 7,
      status: false,
      isPublic: true,
    },
    {
      title: " نقلیه کمکی",
      price: 0,
      vehValue: "",
      noe: "",
      capacity: "",
      id: 8,
      status: false,
      isPublic: true,
    },
    {
      title: " هوا",
      weather: "",
      id: 9,
      status: false,
      isPublic: true,
    },
    { title: " زمان", datepick: "", id: 10, status: false, isPublic: true },
    { title: " محل", name: "", id: 11, status: false, isPublic: true },
    { title: " مبدا", name: "", id: 12 },
    { title: "ظرفیت", name: 0, id: 13, status: false, isPublic: true },
    { title: "نمایشی", name: 0, id: 14, status: false, isPublic: true },
    { title: " بیمه", price: 0, id: 15, status: false, isPublic: true },
    {
      title: " ترنسفر",
      name: "",
      value: "",
      trans: "",
      id: 16,
      status: false,
      isPublic: true,
    },
    { title: " ترنسفر قیمت", price: 0, id: 17, status: false, isPublic: true },
    { title: " سیم کارت", price: 0, id: 18, status: false, isPublic: true },
    {
      title: "نام ترنسفر",
      name: "",
      value: "",
      trans: "",
      id: 19,
      status: false,
      isPublic: true,
    },
  ],
  [
    {
      title: "گشت صبح",
      price: 0,
      id: 0,
      onvan: "",
      description: "",
      status: false,
      isPublic: true,
    },
    {
      title: "صبحانه",
      price: 0,
      id: 1,
      foodName: "",
      resturan: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "ناهار",
      price: 0,
      id: 2,
      foodName: "",
      resturan: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "میان وعده",
      price: 0,
      id: 3,
      onvan: "",
      status: false,
      isPublic: true,
    },
    {
      title: "گشت عصر ",
      price: 0,
      onvan: "",
      description: "",
      id: 4,
      status: false,
      isPublic: true,
    },
    {
      title: "شام",
      price: 0,
      id: 5,
      foodName: "",
      resturan: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "اقامتگاه",
      price: 0,
      id: 6,
      onvan: "",
      noe: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "برنامه شب",
      price: 0,
      onvan: "",
      description: "",
      id: 7,
      status: false,
      isPublic: true,
    },
    {
      title: " نقلیه کمکی",
      price: 0,
      vehValue: "",
      noe: "",
      capacity: "",
      id: 8,
      status: false,
      isPublic: true,
    },
    {
      title: " هوا",
      weather: "",
      id: 9,
      status: false,
      isPublic: true,
    },
  ],
  [
    {
      title: "گشت صبح",
      price: 0,
      id: 0,
      onvan: "",
      description: "",
      status: false,
      isPublic: true,
    },
    {
      title: "صبحانه",
      price: 0,
      id: 1,
      foodName: "",
      resturan: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "ناهار",
      price: 0,
      id: 2,
      foodName: "",
      resturan: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "میان وعده",
      price: 0,
      id: 3,
      onvan: "",
      status: false,
      isPublic: true,
    },
    {
      title: "گشت عصر ",
      price: 0,
      onvan: "",
      description: "",
      id: 4,
      status: false,
      isPublic: true,
    },
    {
      title: "شام",
      price: 0,
      id: 5,
      foodName: "",
      resturan: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "اقامتگاه",
      price: 0,
      id: 6,
      onvan: "",
      noe: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "برنامه شب",
      price: 0,
      onvan: "",
      description: "",
      id: 7,
      status: false,
      isPublic: true,
    },
    {
      title: " نقلیه کمکی",
      price: 0,
      changeHandlerNoe: "",
      noe: "",
      capacity: "",
      id: 8,
      status: false,
      isPublic: true,
    },
    {
      title: " هوا",
      weather: "",
      id: 9,
      status: false,
      isPublic: true,
    },
  ],
  [
    {
      title: "گشت صبح",
      price: 0,
      id: 0,
      onvan: "",
      description: "",
      status: false,
      isPublic: true,
    },
    {
      title: "صبحانه",
      price: 0,
      id: 1,
      foodName: "",
      resturan: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "ناهار",
      price: 0,
      id: 2,
      foodName: "",
      resturan: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "میان وعده",
      price: 0,
      id: 3,
      onvan: "",
      status: false,
      isPublic: true,
    },
    {
      title: "گشت عصر ",
      price: 0,
      onvan: "",
      description: "",
      id: 4,
      status: false,
      isPublic: true,
    },
    {
      title: "شام",
      price: 0,
      id: 5,
      foodName: "",
      resturan: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "اقامتگاه",
      price: 0,
      id: 6,
      onvan: "",
      noe: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "برنامه شب",
      price: 0,
      onvan: "",
      description: "",
      id: 7,
      status: false,
      isPublic: true,
    },
    {
      title: " نقلیه کمکی",
      price: 0,
      vehValue: "",
      noe: "",
      capacity: "",
      id: 8,
      status: false,
      isPublic: true,
    },
    {
      title: " هوا",
      weather: "",
      id: 9,
      status: false,
      isPublic: true,
    },
  ],
  [
    {
      title: "گشت صبح",
      price: 0,
      id: 0,
      onvan: "",
      description: "",
      status: false,
      isPublic: true,
    },
    {
      title: "صبحانه",
      price: 0,
      id: 1,
      foodName: "",
      resturan: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "ناهار",
      price: 0,
      id: 2,
      foodName: "",
      resturan: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "میان وعده",
      price: 0,
      id: 3,
      onvan: "",
      status: false,
      isPublic: true,
    },
    {
      title: "گشت عصر ",
      price: 0,
      onvan: "",
      description: "",
      id: 4,
      status: false,
      isPublic: true,
    },
    {
      title: "شام",
      price: 0,
      id: 5,
      foodName: "",
      resturan: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "اقامتگاه",
      price: 0,
      id: 6,
      onvan: "",
      noe: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "برنامه شب",
      price: 0,
      onvan: "",
      description: "",
      id: 7,
      status: false,
      isPublic: true,
    },
    {
      title: " نقلیه کمکی",
      price: 0,
      vehValue: "",
      noe: "",
      capacity: "",
      id: 8,
      status: false,
      isPublic: true,
    },
    {
      title: " هوا",
      weather: "",
      id: 9,
      status: false,
      isPublic: true,
    },
  ],
  [
    {
      title: "گشت صبح",
      price: 0,
      id: 0,
      onvan: "",
      description: "",
      status: false,
      isPublic: true,
    },
    {
      title: "صبحانه",
      price: 0,
      id: 1,
      foodName: "",
      resturan: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "ناهار",
      price: 0,
      id: 2,
      foodName: "",
      resturan: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "میان وعده",
      price: 0,
      id: 3,
      onvan: "",
      status: false,
      isPublic: true,
    },
    {
      title: "گشت عصر ",
      price: 0,
      onvan: "",
      description: "",
      id: 4,
      status: false,
      isPublic: true,
    },
    {
      title: "شام",
      price: 0,
      id: 5,
      foodName: "",
      resturan: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "اقامتگاه",
      price: 0,
      id: 6,
      onvan: "",
      noe: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "برنامه شب",
      price: 0,
      onvan: "",
      description: "",
      id: 7,
      status: false,
      isPublic: true,
    },
    {
      title: " نقلیه کمکی",
      price: 0,
      vehValue: "",
      noe: "",
      capacity: "",
      id: 8,
      status: false,
      isPublic: true,
    },
    {
      title: " هوا",
      weather: "",
      id: 9,
      status: false,
      isPublic: true,
    },
  ],
  [
    {
      title: "گشت صبح",
      price: 0,
      id: 0,
      onvan: "",
      description: "",
      status: false,
      isPublic: true,
    },
    {
      title: "صبحانه",
      price: 0,
      id: 1,
      foodName: "",
      resturan: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "ناهار",
      price: 0,
      id: 2,
      foodName: "",
      resturan: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "میان وعده",
      price: 0,
      id: 3,
      onvan: "",
      status: false,
      isPublic: true,
    },
    {
      title: "گشت عصر ",
      price: 0,
      onvan: "",
      description: "",
      id: 4,
      status: false,
      isPublic: true,
    },
    {
      title: "شام",
      price: 0,
      id: 5,
      foodName: "",
      resturan: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "اقامتگاه",
      price: 0,
      id: 6,
      onvan: "",
      noe: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "برنامه شب",
      price: 0,
      onvan: "",
      description: "",
      id: 7,
      status: false,
      isPublic: true,
    },
    {
      title: " نقلیه کمکی",
      price: 0,
      vehValue: "",
      noe: "",
      capacity: "",
      id: 8,
      status: false,
      isPublic: true,
    },
    {
      title: " هوا",
      weather: "",
      id: 9,
      status: false,
      isPublic: true,
    },
  ],
  [
    {
      title: "گشت صبح",
      price: 0,
      id: 0,
      onvan: "",
      description: "",
      status: false,
      isPublic: true,
    },
    {
      title: "صبحانه",
      price: 0,
      id: 1,
      foodName: "",
      resturan: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "ناهار",
      price: 0,
      id: 2,
      foodName: "",
      resturan: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "میان وعده",
      price: 0,
      id: 3,
      onvan: "",
      status: false,
      isPublic: true,
    },
    {
      title: "گشت عصر ",
      price: 0,
      onvan: "",
      description: "",
      id: 4,
      status: false,
      isPublic: true,
    },
    {
      title: "شام",
      price: 0,
      id: 5,
      foodName: "",
      resturan: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "اقامتگاه",
      price: 0,
      id: 6,
      onvan: "",
      noe: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "برنامه شب",
      price: 0,
      onvan: "",
      description: "",
      id: 7,
      status: false,
      isPublic: true,
    },
    {
      title: " نقلیه کمکی",
      price: 0,
      vehValue: "",
      noe: "",
      capacity: "",
      id: 8,
      status: false,
      isPublic: true,
    },
    {
      title: " هوا",
      weather: "",
      id: 9,
      status: false,
      isPublic: true,
    },
  ],
  [
    {
      title: "گشت صبح",
      price: 0,
      id: 0,
      onvan: "",
      description: "",
      status: false,
      isPublic: true,
    },
    {
      title: "صبحانه",
      price: 0,
      id: 1,
      foodName: "",
      resturan: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "ناهار",
      price: 0,
      id: 2,
      foodName: "",
      resturan: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "میان وعده",
      price: 0,
      id: 3,
      onvan: "",
      status: false,
      isPublic: true,
    },
    {
      title: "گشت عصر ",
      price: 0,
      onvan: "",
      description: "",
      id: 4,
      status: false,
      isPublic: true,
    },
    {
      title: "شام",
      price: 0,
      id: 5,
      foodName: "",
      resturan: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "اقامتگاه",
      price: 0,
      id: 6,
      onvan: "",
      noe: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "برنامه شب",
      price: 0,
      onvan: "",
      description: "",
      id: 7,
      status: false,
      isPublic: true,
    },
    {
      title: " نقلیه کمکی",
      price: 0,
      vehValue: "",
      noe: "",
      capacity: "",
      id: 8,
      status: false,
      isPublic: true,
    },
    {
      title: " هوا",
      weather: "",
      id: 9,
      status: false,
      isPublic: true,
    },
  ],
  [
    {
      title: "گشت صبح",
      price: 0,
      id: 0,
      onvan: "",
      description: "",
      status: false,
      isPublic: true,
    },
    {
      title: "صبحانه",
      price: 0,
      id: 1,
      foodName: "",
      resturan: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "ناهار",
      price: 0,
      id: 2,
      foodName: "",
      resturan: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "میان وعده",
      price: 0,
      id: 3,
      onvan: "",
      status: false,
      isPublic: true,
    },
    {
      title: "گشت عصر ",
      price: 0,
      onvan: "",
      description: "",
      id: 4,
      status: false,
      isPublic: true,
    },
    {
      title: "شام",
      price: 0,
      id: 5,
      foodName: "",
      resturan: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "اقامتگاه",
      price: 0,
      id: 6,
      onvan: "",
      noe: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "برنامه شب",
      price: 0,
      onvan: "",
      description: "",
      id: 7,
      status: false,
      isPublic: true,
    },
    {
      title: " نقلیه کمکی",
      price: 0,
      vehValue: "",
      noe: "",
      capacity: "",
      id: 8,
      status: false,
      isPublic: true,
    },
    {
      title: " هوا",
      weather: "",
      id: 9,
      status: false,
      isPublic: true,
    },
  ],
  [
    {
      title: "گشت صبح",
      price: 0,
      id: 0,
      onvan: "",
      description: "",
      status: false,
      isPublic: true,
    },
    {
      title: "صبحانه",
      price: 0,
      id: 1,
      foodName: "",
      resturan: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "ناهار",
      price: 0,
      id: 2,
      foodName: "",
      resturan: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "میان وعده",
      price: 0,
      id: 3,
      onvan: "",
      status: false,
      isPublic: true,
    },
    {
      title: "گشت عصر ",
      price: 0,
      onvan: "",
      description: "",
      id: 4,
      status: false,
      isPublic: true,
    },
    {
      title: "شام",
      price: 0,
      id: 5,
      foodName: "",
      resturan: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "اقامتگاه",
      price: 0,
      id: 6,
      onvan: "",
      noe: "",
      tel: "",
      address: "",
      status: false,
      isPublic: true,
    },
    {
      title: "برنامه شب",
      price: 0,
      onvan: "",
      description: "",
      id: 7,
      status: false,
      isPublic: true,
    },
    {
      title: " نقلیه کمکی",
      price: 0,
      vehValue: "",
      noe: "",
      capacity: "",
      id: 8,
      status: false,
      isPublic: true,
    },
    {
      title: " هوا",
      weather: "",
      id: 9,
      status: false,
      isPublic: true,
    },
  ],
];

const reducer = (state, action) => {
  switch (action.type) {
    case "changeHandler": {
      const allDays = [...state];
      allDays[action.day][action.id].price = removeCommas(action.event.target.value);
      return allDays;
    }
    case "changeHandlerOnvan": {
      const allDays = [...state];
      allDays[action.day][action.id].onvan = action.event.target.value;
      console.log("in context allDays[action.day][action.id].onvan:", allDays[action.day][action.id].onvan);
      return allDays;
    }
    case "changeHandlerDesc": {
      const allDays = [...state];
      allDays[action.day][action.id].description = action.event.target.value;
      return allDays;
    }
    case "changeHandlerAddress": {
      const allDays = [...state];
      allDays[action.day][action.id].address = action.event.target.value;
      return allDays;
    }
    case "changeHandlerFood": {
      const allDays = [...state];
      allDays[action.day][action.id].foodName = action.event.target.value;
      return allDays;
    }
    case "changeHandlerResturan": {
      const allDays = [...state];
      allDays[action.day][action.id].resturan = action.event.target.value;
      return allDays;
    }
    case "changeHandlerTel": {
      const allDays = [...state];
      allDays[action.day][action.id].tel = removeCommas(action.event.target.value);
      return allDays;
    }
    case "changeHandlerWeather": {
      const allDays = [...state];
      allDays[action.day][9].weather = action.event.target.value;
      return allDays;
    }
    case "changeHandlerStatus": {
      const allDays = [...state];
      allDays[action.day][action.mealId].status = !allDays[action.day][action.mealId].status;
      return allDays;
    }
    case "changeHandlerPublic": {
      const allDays = [...state];
      allDays[action.day][action.mealId].isPublic = !allDays[action.day][action.mealId].isPublic;
      return allDays;
    }
    case "changer": {
      const allDays = [...state];
      switch (action.id) {
        case 12:
          allDays[0][action.id].name = translateToReactSelect([action.event], true)[0];
          break;
        case 11:
          allDays[0][action.id].name = action.event.target.value;

          break;

        default:
          allDays[0][action.id].name = removeCommas(action.event.target.value);
      }

      return allDays;
    }
    case "changeDate": {
      const allDays = [...state];
      allDays[0][10].datepick = action.value;
      return allDays;
    }
    case "changeHandlerCapacity": {
      const allDays = [...state];
      allDays[action.day][action.id].capacity = removeCommas(action.event.target.value);
      return allDays;
    }
    case "changeHandlerNoe": {
      const allDays = [...state];
      allDays[action.day][action.id].noe = action.value;
      return allDays;
    }
    case "changeHandlerNoeEghamat": {
      const allDays = [...state];
      allDays[action.day][action.id].noeEghamat = action.event.target.value;
      return allDays;
    }
    case "changeHandlerVehicle": {
      const allDays = [...state];
      allDays[action.day][action.id].vehValue = action.event.target.value;
      return allDays;
    }
    case "changeHandlerTrans": {
      const allDays = [...state];
      allDays[0][action.id].trans = action.event.target.value;
      return allDays;
    }
    case "changing": {
      const allDays = [...state];
      allDays[0][action.id].price = removeCommas(action.event.target.value);

      return allDays;
    }
    case "addMealsHandler": {
      const allDays = [...state];
      for (let index1 = 0; index1 < allDays[action.day].length; index1++) {
        let temp = false;
        for (let index2 = 0; index2 < action.activeItems.length; index2++) {
          if (state[action.day][index1].id == action.activeItems[index2]) {
            temp = true;
            allDays[action.day][index1].status = true;
          }
        }
        if (!temp) {
          allDays[action.day][index1].status = false;
        }
      }
      return allDays;
    }
    case "reset": {
      const allDays = [...state];
      loop2: for (let index2 = 0; index2 < allDays[action.dayNum].length; index2++) {
        loop3: for (const key in allDays[action.dayNum][index2]) {
          if (key != "id" && key != "title") {
            switch (key) {
              case "price":
                allDays[action.dayNum][index2][key] = 0;
                break;
              case "status":
                allDays[action.dayNum][index2][key] = false;
                break;
              default:
                allDays[action.dayNum][index2][key] = "";
                break;
            }
          }
        }
      }

      return allDays;
    }
    case "firstDayReset": {
      const allDays = [...state];
      for (let eachDay = 1; eachDay < allDays.length; eachDay++) {
        for (let index = 0; index < allDays[eachDay].length; index++) {
          allDays[eachDay][index].price = 0;
        }
      }

      return allDays;
    }
    case "clearPrice": {
      const allDays = [...state];
      allDays[action.dayId][action.mealId].price = 0;
      return allDays;
    }
    case "setAsyncData": {
      const allDays = [...state];
      console.log("allDay", allDays);
      // action : data
      const optionDasteBandi = [
        { label: " قایق", value: "ghayegh" },
        { label: " نیسان", value: "neysan" },
        { label: " offroad", value: "offroad" },
        { label: " تراکتور", value: "tractor" },
        { label: " موتور سه چرخ", value: "secharkh" },
      ];
      for (let dayNumber = 0; dayNumber < action.data.length; dayNumber++) {
        for (let mealNumber = 0; mealNumber < action.data[dayNumber].length; mealNumber++) {
          const orginalMeal = allDays[dayNumber][mealNumber],
            newMeal = action.data[dayNumber][mealNumber];
          switch (action.data[dayNumber][mealNumber].id) {
            case 0:
              orginalMeal.description = newMeal.description;
              orginalMeal.onvan = newMeal.onvan;
              orginalMeal.price = newMeal.price;
              orginalMeal.status = newMeal.status;
              orginalMeal.isPublic = newMeal.isPublic;
              console.log("isPublic", newMeal);
              break;
            case 1:
              orginalMeal.address = newMeal.address;
              orginalMeal.foodName = newMeal.foodName;
              orginalMeal.price = newMeal.price;
              orginalMeal.resturan = newMeal.resturan;
              orginalMeal.status = newMeal.status;
              orginalMeal.tel = newMeal.tel;
              orginalMeal.isPublic = newMeal.isPublic;
              break;
            case 2:
              orginalMeal.address = newMeal.address;
              orginalMeal.foodName = newMeal.foodName;
              orginalMeal.price = newMeal.price;
              orginalMeal.resturan = newMeal.resturan;
              orginalMeal.status = newMeal.status;
              orginalMeal.tel = newMeal.tel;
              orginalMeal.isPublic = newMeal.isPublic;
              break;
            case 3:
              orginalMeal.onvan = newMeal.onvan;
              orginalMeal.price = newMeal.price;
              orginalMeal.status = newMeal.status;
              orginalMeal.isPublic = newMeal.isPublic;
              break;
            case 4:
              orginalMeal.description = newMeal.description;
              orginalMeal.onvan = newMeal.onvan;
              orginalMeal.price = newMeal.price;
              orginalMeal.status = newMeal.status;
              orginalMeal.isPublic = newMeal.isPublic;
              break;
            case 5:
              orginalMeal.address = newMeal.address;
              orginalMeal.foodName = newMeal.foodName;
              orginalMeal.price = newMeal.price;
              orginalMeal.resturan = newMeal.resturan;
              orginalMeal.status = newMeal.status;
              orginalMeal.tel = newMeal.tel;
              orginalMeal.isPublic = newMeal.isPublic;
              break;
            case 6:
              orginalMeal.address = newMeal.address;
              orginalMeal.noeEghamat = newMeal.noeEghamat;
              orginalMeal.price = newMeal.price;
              orginalMeal.status = newMeal.status;
              orginalMeal.tel = newMeal.tel;
              orginalMeal.onvan = newMeal.onvan;
              orginalMeal.isPublic = newMeal.isPublic;

              break;
            case 7:
              orginalMeal.description = newMeal.description;
              orginalMeal.onvan = newMeal.onvan;
              orginalMeal.price = newMeal.price;
              orginalMeal.status = newMeal.status;
              orginalMeal.isPublic = newMeal.isPublic;
              break;
            case 8:
              orginalMeal.capacity = newMeal.capacity;
              orginalMeal.isPublic = newMeal.isPublic;
              orginalMeal.price = newMeal.price;
              orginalMeal.status = newMeal.status;
              orginalMeal.vehValue = newMeal.vehValue;

              let newSelected = optionDasteBandi.find((value) => {
                return value.label == newMeal.noe;
              });
              if (newSelected) {
                orginalMeal.noe = translateToReactSelect([newSelected], true);
              } else {
                orginalMeal.noe = "";
              }

              break;
            case 9:
              orginalMeal.weather = newMeal.weather;
              break;
            case 10:
              orginalMeal.datepick = newMeal.datepick;
              break;
            case 11:
              orginalMeal.name = newMeal.name;
              break;
            case 12:
              orginalMeal.name = newMeal.name;
              break;
            case 13:
              orginalMeal.name = newMeal.name;
              break;
            case 14:
              orginalMeal.name = newMeal.name;
              break;
            case 15:
              orginalMeal.price = newMeal.price;
              break;
            case 16:
              orginalMeal.name = newMeal.name;
              orginalMeal.trans = newMeal.trans;
              orginalMeal.value = newMeal.value;
              break;
            case 17:
              orginalMeal.price = newMeal.price;
              break;
            case 18:
              orginalMeal.price = newMeal.price;
              break;
            case 19:
              orginalMeal.name = newMeal.name;
              orginalMeal.trans = newMeal.trans;
              orginalMeal.value = newMeal.value;

              break;

            default:
              break;
          }
        }
      }

      return allDays;
    }
    default:
      return state;
  }
};

const MealProvider = ({ children }) => {
  const [Meals, dispatch] = useReducer(reducer, initialState);

  return (
    <div>
      <MealContext.Provider value={Meals}>
        <MealContextDispatcher.Provider value={dispatch}>{children}</MealContextDispatcher.Provider>
      </MealContext.Provider>
    </div>
  );
};

export default MealProvider;

export const useMeals = () => useContext(MealContext);
export const useMealsAction = () => useContext(MealContextDispatcher);
